import React, { useState } from 'react';
import { Link, useLoaderData } from 'react-router-dom';
import useTitle from '../../Hooks/useTitle';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import 'swiper/css/pagination';
import { Autoplay, EffectCoverflow, Pagination } from "swiper/modules";
import { FaLongArrowAltLeft } from 'react-icons/fa';
import toast from 'react-hot-toast';
import { useQuery } from 'react-query';
import { format } from 'date-fns';

const ProjectsDetails = () => {
    useTitle("Details");
    const [laodiing, setLoading] = useState(false);
    const [readMore, setReadMore] = useState(false);
    const [error, setError] = useState('');
    const projects = useLoaderData();

    const { data: comments = [], refetch } = useQuery({
        queryKey: ['comment'],
        queryFn: async () => {
            const res = await fetch(`https://shakil-server.vercel.app/comment`);
            const data = await res.json();
            const filteredData = data.filter(dt => dt.projectsName === projects.name);
            return filteredData;
        }
    })
    refetch();

    if (!projects) {
        return <div className='flex justify-center items-center w-full min-h-[80vh] text-4xl'>
            <span className="loading text-accent loading-dots"></span>
        </div>
    }

    const FaHandleComment = (event) => {
        event.preventDefault();
        const name = event.target.name.value;
        const email = event.target.email.value;
        const message = event.target.message.value;
        setError('');

        if (message === '' || email === '') {
            setError(`${message === '' ? 'Message is required' : 'Email is requird'}`);
            return;
        }
        const comment = {
            projectsName: projects.name,
            date: format(new Date(), 'PPpp'),
            name,
            email,
            message
        };

        setLoading(true);
        fetch('https://shakil-server.vercel.app/comment', {
            method: "POST",
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(comment)
        })
            .then(res => res.json())
            .then(data => {
                if (data.acknowledged) {
                    setLoading(false);
                    toast.success(`${name} - Thank you for your feedback`);
                    event.target.reset();
                }
            })
    }

    return (
        <div className='px-5 md:px-20 lg-px-32 relative max-w-[1400px] m-auto'>
            <h1 className='text-4xl text-center font-bold py-14 md:py-10 lg:py-10'>{projects?.name}</h1>
            <Link to='/projects' className='flex items-center gap-2 text-xs absolute top-5 left-5 md:left-32 lg:left-32 hover:text-red-500'>Back to projects <FaLongArrowAltLeft /></Link>

            <div className='py-5'>
                <Swiper
                    effect={"coverflow"}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={3}
                    spaceBetween={30}
                    coverflowEffect={{
                        rotate: 0,
                        stretch: 0,
                        depth: 700,
                        modifier: 1,
                        slideShadows: true,
                    }}
                    pagination={{
                        clickable: true
                    }}
                    initialSlide={Math.floor(projects.images.length / 2 - 1)}
                    modules={[Autoplay, EffectCoverflow, Pagination]}
                    className="w-full"
                >
                    {
                        projects.images.map(image => <SwiperSlide className="bg-center mb-14 bg-cover w-full" key={image.id}>
                            <PhotoProvider>
                                <PhotoView src={image?.img}>
                                    <img src={image?.img} className='w-full block h-44 md:h-80 lg:h-80  rounded' alt="" />
                                </PhotoView>
                            </PhotoProvider>
                        </SwiperSlide>)
                    }
                </Swiper>
            </div>
            <div className='flex gap-4 md:gap-10 lg:gap-10 justify-start mt-10'>
                <Link to={projects?.liveServer} title={projects?.name} className='text-xs font-bold btn btn-sm  btn-accent md:px-12 lg:px-12' target='_blank'>Live Site</Link>

                <Link to={projects?.clientSite} title={projects?.name} className='text-xs font-bold btn btn-sm  btn-accent' target='_blank'>Client Site<span className='hidden md:block lg:block'>-Source Code</span></Link>
                {
                    projects.serevrSite &&
                    <Link to={projects?.serevrSite} title={projects?.name} className='text-xs font-bold btn btn-sm  btn-accent' target='_blank'>Server Site<span className='hidden md:block lg:block'>-Source Code</span></Link>
                }
            </div>
            <div className='py-10'>
                <h1 className='text-xl font-medium'>USED MATERIALS</h1>
                <div className='flex flex-wrap gap-2 md:gap-5 lg:gap-5 mt-4 opacity-80'>
                    {
                        projects?.materials.map(material => <p key={material.id} className='btn btn-outline text-white cursor-default hover:btn-accent btn-xs px-4 font-bold'>
                            {material?.name}
                        </p>)
                    }
                </div>
                <div className='mt-10'>
                    <h1 className='text-xl font-medium mb-2'>DESCRIPTIONS</h1>
                    {
                        projects?.description.map((descript, i) => <p key={i} className='font-medium hover:text-teal-300 cursor-default opacity-80'>
                            {i + 1}. {descript}
                        </p>)
                    }
                </div>
            </div>

            {/* Show comment section */}
            <div className='my-20'>
                <h1 className='text-xl font-medium mb-8 text-center'>FEEDBACK</h1>
                <Swiper
                    effect={"coverflow"}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={1}
                    spaceBetween={30}
                    coverflowEffect={{
                        rotate: 0,
                        stretch: 3,
                        depth: 700,
                        modifier: 0,
                        slideShadows: true,
                    }}
                    loop={true}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        dynamicBullets: true,
                        clickable: true
                    }}
                    initialSlide={Math.floor(comments.length / 2 - 1)}
                    modules={[Autoplay, EffectCoverflow, Pagination]}
                    className="w-full py-96"
                >
                    {
                        comments.map(comment => <SwiperSlide className="bg-center mb-8 rounded bg-cover w-full h-full" key={comment._id}>
                            <div className={`rounded p-5 bg-indigo-900 shadow-2xl  text-center ${readMore ? 'h-full' : 'h-full md:h-full lg:h-56'} w-full`}>
                                <div className=' mb-4 flex justify-between'>
                                    <p className='text-xs font-bold'>{comment?.date}</p>
                                    <p className='font-bold text-xs text-teal-300'>{comment?.projectsName}</p>
                                </div>
                                <p className='mb-5 opacity-90'>
                                    {
                                        comment?.message.length > 250 ?
                                            <div>
                                                <p className='text-justify'>
                                                    {
                                                        readMore ?
                                                            comment?.message
                                                            :
                                                            comment?.message.slice(0, 350)
                                                    }
                                                    {
                                                        readMore ?
                                                            <button onClick={() => setReadMore(false)} className='text-xs text-red-500 pl-2 font-bold hover:text-red-600'> Read less</button>
                                                            :
                                                            <button onClick={() => setReadMore(true)} className='text-xs text-teal-300 font-bold hover:text-teal-500'>...Read more</button>
                                                    }
                                                </p>
                                            </div>
                                            :
                                            comment?.message

                                    }
                                </p>
                                <div className=''>
                                    <h1 className='font-bold'>{comment?.name}</h1>
                                    <p className='text-xs font-bold'>{comment?.email}</p>
                                </div>
                            </div>
                        </SwiperSlide>)
                    }
                </Swiper>
            </div>


            {/* Leave A comment */}
            <div className='py-16 md:w-full lg:w-1/2 mx-auto'>
                <h1 className='text-2xl font-medium text-center mb-5'>Leave Your Feedback</h1>
                <form onSubmit={FaHandleComment} className='flex flex-col'>

                    <input type="text" placeholder="Your name" name="name" className="outline-none border-b-2 py-1 w-full mb-5 text-sm bg-indigo-950 font-bold" />

                    <input type="email" placeholder="Your email" name="email" className="outline-none border-b-2 py-1 w-full text-sm mb-2 bg-indigo-950 font-bold" />

                    <textarea className="outline-none border-b-2 py-1 mb-2 bg-indigo-950 font-bold" name='message' placeholder="Write your comment"></textarea>

                    <span className='text-xs font-bold text-red-500'>{error}</span>

                    <button type="submit" className={`btn btn-md bg-teal-300 font-bold hover:bg-teal-500 text-indigo-950 mt-5`}>
                        {
                            laodiing ?
                                'Sending...'
                                :
                                'Send'
                        }
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ProjectsDetails;